import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import useMediaStore from '../stores/media';
import usePlaylistStore from '../stores/playlist';

const useAudioTimeDisplay = () => {
  const mediaStore = useMediaStore();
  const playlistStore = usePlaylistStore();

  const { currentPlayerTime, audioDuration } = storeToRefs(mediaStore);
  const { totalDuration, currentPlaylistTime } = storeToRefs(playlistStore);

  /**
   * Format seconds to hh:mm:ss or mm:ss format
   */
  const formatTime = (seconds: number): string => {
    if (!isFinite(seconds) || seconds < 0) {
      return '00:00';
    }

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (hours > 0) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Time-based mode (track times)
  const currentTimeFormatted = computed(() => formatTime(currentPlayerTime.value));
  const remainingTrackTime = computed(() => Math.max(0, audioDuration.value - currentPlayerTime.value));
  const remainingTrackTimeFormatted = computed(() => `-${formatTime(remainingTrackTime.value)}`);

  // Playlist mode (playlist times)
  const currentPlaylistTimeFormatted = computed(() => formatTime(currentPlaylistTime.value));
  const remainingPlaylistTime = computed(() => Math.max(0, totalDuration.value - currentPlaylistTime.value));
  const remainingPlaylistTimeFormatted = computed(() => `-${formatTime(remainingPlaylistTime.value)}`);

  return {
    currentTimeFormatted,
    remainingTrackTimeFormatted,
    currentPlaylistTimeFormatted,
    remainingPlaylistTimeFormatted,
    formatTime,
  };
};

export default useAudioTimeDisplay;
